/**
 * DoubleClick Ads
 */


/* declare namespace */
var IVYEXEC = IVYEXEC || {};

/* viewport handler class */
IVYEXEC.Viewporter = function() {

    var mobile =     0;
    var tablet =      1;
    var desktop =   2;

    // default desktop crossmark
    var desktop_low_range = 1200;
    // default tablet crossmark
    var tablet_low_range = 480;

    this.setDesktopLowRange = function(value) {
            desktop_low_range = value;
    };

    this.setTabletLowRange = function(value) {
            tablet_low_range = value;
    };

    this.getMobileId = function() {
            return mobile;
    };

    this.getTabletId = function() {
            return tablet;
    };

    this.getDesktopId = function() {
            return desktop;
    };

    this.getViewportDimensions = function() {

          var w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          var h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

          return {
              width: w,
              height: h
          };

    };

    this.isMobile = function() {
              return this.getViewportDimensions().width < tablet_low_range;
    };

    this.isTablet = function() {
              return this.getViewportDimensions().width < desktop_low_range && this.getViewportDimensions().width >= tablet_low_range;
    };

    this.isDesktop = function() {
              return this.getViewportDimensions().width >= desktop_low_range;
    };

    this.isLandscape = function() {
              var viewport = this.getViewportDimensions();
              return viewport.width/viewport.height > 1;
    };

    this.isPortrait = function() {
              var viewport = this.getViewportDimensions();
              return viewport.width/viewport.height < 1;
    };

    this.isResolutionMatched = function(device) {
              if(device === mobile) {
                    if(this.isMobile()) {
                        return true;
                    }
              } else if (device === tablet) {
                    if(this.isTablet()) {
                        return true;
                    }
              } else if (device === desktop) {
                    if(this.isDesktop()) {
                        return true;
                    }
              }
              return false;
    };

};


/** Ad repositioner **/
IVYEXEC.AdRepositioner = function() {

        var ad_bus = null;

        this.setupBus = function(bus) {
            ad_bus = bus;
            return this;
        };

        this.getBus = function() {
            return ad_bus;
        };

        this.repositionAd = function(slot, css, device, condition) {

              if(typeof(device) === "undefined") {
                  device = [this.getBus().getViewporter().getMobileId()];
              }

              var resolutionConditionsUnmatched = false;
              for(var i = 0; i < device.length; i++) {
                    if(this.getBus().getViewporter().isResolutionMatched(device[i]) || resolutionConditionsUnmatched) {
                        resolutionConditionsUnmatched = true;
                    }
              }

              if(resolutionConditionsUnmatched === false) {
                  return false;
              }

              if(typeof(condition) !== "undefined") {
                  if(condition() === true) {
                      return this.moveAd(slot, css);
                  }
              } else {
                  return this.moveAd(slot, css);
              }

              return false;

    };

    this.moveAd = function(slot, css) {
            var repositioned_ad = $(slot.destination + " " + slot.source);
              if(repositioned_ad.length === 0) {
                  var source = $(slot.source);
                  var target = $(slot.target);
                  if(typeof(slot.offset) !== "undefined" && typeof(slot.collection) !== "undefined" && slot.collection === true) {
                        target = target.eq(slot.offset);
                        source.insertAfter(target);
                  } else {
                      target.prepend(source);
                  }

                  if(typeof(css) !== "undefined") {
                      source.css(css);
                  }
              }
              return true;
    };

};


/** ads bus **/
IVYEXEC.BusAds = function(gt, config) {

        var ads = [];
        var registered_resizables = [];
        var googletag = gt || null;
        var viewporter = null;
        var ad_repositioner = null;


        this.setAds = function(ad_collection) {
               ads = ad_collection;
               return this;
        };

        // funny name :)
        this.addAd = function(ad) {
                ads.push(ad.setupBus(this));
                return this;
        };

        this.registerResizable = function() {
                for(var a in ads) {
                    if(ads.resizing === true) {
                        registered_resizables.push(ads[a]);
                    }
                }
        };

        this.resizeAction = function() {
            var self = this; // self reference
            /**
                  *  Refresh all ads on resize
                  */
                $(window).resize(function() {
                                                    clearTimeout(window.resizedFinished);
                                                    window.resizedFinished = setTimeout(function(){

                                                        for(var d in ads) {
                                                            if(ads[d].resizing === true) {
                                                                ads[d].onResize();
                                                            }
                                                        }

                                                        /*** once again refresh the ads ***/
                                                        self.refreshAllSlots();

                                                    }, 250);
                });

        };

        this.setupGoogleTag = function(gt) {
                googletag = gt;
                return this;
        };

        this.setupViewporter = function(vp) {
                viewporter = vp;
                return this;
        };

        this.getViewporter = function() {
                return viewporter;
        };

        this.setupAdRepositioner = function(ar) {
                ad_repositioner = ar;
                ad_repositioner.setupBus(this);
                return this;
        };

        this.getAdRepositioner = function() {
                return ad_repositioner;
        };

        this.fetchAds =  function() {
                /* prepare ads */
                for(var s in ads) {
                    ads[s].prepare();
                }
                /* Start fetching the ads */
                googletag.cmd.push(function() {
                        googletag.pubads().enableSingleRequest();
                        googletag.enableServices();
                });
                /* display ads */
                for(var x in ads) {
                    ads[x].engage();
                }
        };

        // refresh all slots, or only passed ones as argument
        this.refreshAllSlots = function(slots) {
                googletag.cmd.push(function() {
                                                        if(typeof(slots) !== "undefined") {
                                                            googletag.pubads().refresh(slots);
                                                        } else {
                                                            googletag.pubads().refresh();
                                                        }

               });
        };

        this.startEngine = function() {
                this.registerResizable();
                this.fetchAds();
                this.resizeAction();
        };


        // constructor
        (function(self){
            if(typeof(config) !== "undefined") {
                for(var o in config) {
                    var ad = new IVYEXEC[config[o].class]();
                    ad.setId(config[o].id);
                    ad.setAdSelector(config[o].selector);
                    if(typeof(config[o].resize) !== "undefined") {
                        ad.setResizing(config[o].resize);
                    }
                    ad.setupGoogleTag(googletag);
                    self.addAd(ad);
                }
            }
        })(this);


};


/** base ad class **/
IVYEXEC.Ad = function() {

        var ad_bus = null;
        var googletag = null;
        this.id = null;
        this.resizing = false;
        this.ad_selector = null;
        this.slot = null;

        this.setupBus = function(bus) {
            ad_bus = bus;
            return this;
        };

        this.getBus = function() {
            return ad_bus;
        };

        this.setupGoogleTag = function(gt) {
            googletag = gt;
            return this;
        };

        this.setId = function(id) {
            this.id = id;
            return this;
        };

        this.setAdSelector = function(ad_selector) {
            this.ad_selector = ad_selector;
            return this;
        };

        this.setResizing = function(bool) {
            this.resizing = bool;
            return this;
        };

        this.getSlot = function() {
            return this.slot;
        };

        // meant to be overridden
        this.prepare = function() {
            return this;
        };

        // meant to be overridden if necessary
        this.engage = function() {
            var self = this; // self reference
            googletag.cmd.push(function() { googletag.display(self.ad_selector); });
            return this;
        };

        // meant to be overridden
        this.onResize = function() {
           return this;
        };

};



/**
 * particular ads
 *
 ***/

/* Rectangular ad */
IVYEXEC.RectangularAd = function(){

    this.prepare = function() {
        var self = this; // self reference
        // Rectangular ad 300x250
        googletag.cmd.push(function() {
                self.slot = googletag.defineSlot(self.id, [300, 250], self.ad_selector)
                                                              .addService(googletag.pubads());

        });
    };

    this.engage = function() {
        var self = this; // self reference
        googletag.cmd.push(function() { googletag.display(self.ad_selector); });
        return this;
    };

};
IVYEXEC.RectangularAd.prototype = new IVYEXEC.Ad();
IVYEXEC.RectangularAd.prototype.constructor = IVYEXEC.RectangularAd;

/* Billboard Ad */
IVYEXEC.BillboardAd = function() {

    this.animate = true;

    this.margin = 20;

    this.prepare = function() {

        // Billboard ad 970x250
        var self = this; // self reference
        googletag.cmd.push(function() {
                var mappingAdLeaderboard = googletag.sizeMapping().
                        addSize([1200, 90], [[970, 250], [728, 90]]).
                        //addSize([992, 90], [320, 50]).
                        //addSize([768, 90], [320, 50]).
                        addSize([481, 90], []). // this condition makes sure that the billboard ad will not show on tablet sizes (> 481 && < 1200)
                        addSize([480, 90], [234, 60]).
                        //addSize([320, 50], []).
                        addSize([0, 0], [234, 60]). // this condition makes sure that the billboard ad will show on phones with resolutions < 480
                        // Fits browsers of any size smaller than 320 x 50
                        build();
                self.slot = googletag.defineSlot(self.id,  [[234, 60], [728, 90], [970, 250]], self.ad_selector)
                                                                .defineSizeMapping(mappingAdLeaderboard)
                                                                .setCollapseEmptyDiv(true)
                                                                .addService(googletag.pubads());

        });

    };

    this.engage = function() {

        // hide the ad container out of sight
        this.outOfSight();

        var self = this; // self reference

        googletag.cmd.push(function() { googletag.display(self.ad_selector); });

        // assign event listener to the renderEnded event - push it down only in case of a Desktop
        googletag.cmd.push(function() {

                googletag.pubads().addEventListener('slotRenderEnded', function(event) {
                    if( self.slot === event.slot && self.animate === true && self.getBus().getViewporter().isDesktop() ) { // since this is global event listener (for every slot on page) , filter out only the billboard ad, and do the pushdown only if Desktop
                        /*console.log('Creative with id: ' + event.creativeId +
                          ' is rendered to slot of size: ' + event.size[0] + 'x' + event.size[1]);*/
                                        self.pushDown(event);
                    }
                });

        });

        // in case this is a mobile device resolution, relocate the ad to a different spot
        if( this.getBus().getViewporter().isMobile() ) {

                // hack for clients that do not want mobile billboard ad on leaderboard position
                $("#secondary_ad_location").css("margin", this.margin);

                this.getBus().getAdRepositioner().repositionAd(
                                                                                        {
                                                                                                target: "#secondary_ad_location",
                                                                                                source: "#billboard_ad"
                                                                                        },
                                                                                        {},
                                                                                        [this.getBus().getViewporter().getMobileId(), this.getBus().getViewporter().getTabletId()]
                                                                                    );
                self.showUp();

        } else if ( this.getBus().getViewporter().isDesktop() ) {

            // hack for clients that do not want mobile billboard ad on leaderboard position
            $("#secondary_ad_location").css("margin", this.margin);

        }

    };

    this.outOfSight = function() {
        // hide the container from sight
        $("#" + this.ad_selector).css({
                "opacity": 0,
    	"position": "absolute"
        });
    };

    this.pushDown = function(google_slot) {

        var ad_element = $("#" + this.ad_selector);

        ad_element.css("display", "none").css("opacity", 1).css("position", "relative");

        if(google_slot.size[0] === 970) { // billboard motion
            ad_element.slideDown(1500);
        } else { // leaderboard motion
            ad_element.slideDown(1000);
        }

    };

    this.showUp = function() {
        $("#" + this.ad_selector).css("opacity", 1).css("position", "relative");
    };

    this.onResize = function() {

        // hide the ad container
        this.outOfSight();

        if( this.getBus().getViewporter().isDesktop() ) { // it's desktop resolution

            this.getBus().getAdRepositioner().repositionAd(
                                                                                        {
                                                                                                target: "#primary_ad_location",
                                                                                                source: "#billboard_ad"
                                                                                        },
                                                                                        {},
                                                                                        [this.getBus().getViewporter().getDesktopId()]
                                                                                    );

            // allow event listener on resize
            this.animate = true;

        } else { // it's smaller than desktop

            this.getBus().getAdRepositioner().repositionAd(
                                                                                        {
                                                                                                target: "#secondary_ad_location",
                                                                                                source: "#billboard_ad"
                                                                                        },
                                                                                        {},
                                                                                        [this.getBus().getViewporter().getMobileId(), this.getBus().getViewporter().getTabletId()]
                                                                                    );

            // forbid event listener on resize
            this.animate = false;
            this.showUp();
        }

    };

};
IVYEXEC.BillboardAd.prototype = new IVYEXEC.Ad();
IVYEXEC.BillboardAd.prototype.constructor = IVYEXEC.BillboardAd;

/* LeaderBoard ad */
IVYEXEC.LeaderboardAd = function() {
    this.prepare = function() {
        // Leaderboard ad 728x90
        var self = this; // self reference
                            googletag.cmd.push(function() {
                                    var mappingAdLeaderboard = googletag.sizeMapping().
                                            addSize([1200, 90], [728, 90]).
                                            //addSize([992, 90], [320, 50]).
                                            //addSize([768, 90], [320, 50]).
                                            addSize([481, 90], []). // this condition makes sure that the leaderboard ad will not show on tablet sizes (> 481 && < 1200)
                                            addSize([480, 90], [234, 60]).
                                            //addSize([320, 50], []).
                                            addSize([0, 0], [234, 60]). // this condition makes sure that the leaderboard ad will show on phones with resolutions < 480
                                            // Fits browsers of any size smaller than 320 x 50
                                            build();
                                    self.slot = googletag.defineSlot(self.id,  [[234, 60], [728, 90]], self.ad_selector)
                                                                                    .defineSizeMapping(mappingAdLeaderboard)
                                                                                    .setCollapseEmptyDiv(true)
                                                                                    .addService(googletag.pubads());

                            });
    };

    this.engage = function() {

            googletag.cmd.push(function() { googletag.display(self.ad_selector); });

            if( !this.getBus().getViewporter().isDesktop() ) {

                    this.getBus().getAdRepositioner().repositionAd(
                                                                                            {
                                                                                                    target: "#tertiary_ad_location",
                                                                                                    source: "#leaderboard_ad"
                                                                                            },
                                                                                            {},
                                                                                            [this.getBus().getViewporter().getMobileId(), this.getBus().getViewporter().getTabletId()]
                                                                                        );

            }

    };

    this.onResize = function() {

            if( this.getBus().getViewporter().isDesktop() ) { // it's desktop resolution

                this.getBus().getAdRepositioner().repositionAd(
                                                                                        {
                                                                                                target: "#secondary_ad_location",
                                                                                                source: "#leaderboard_ad"
                                                                                        },
                                                                                        {},
                                                                                        [this.getBus().getViewporter().getDesktopId()]
                                                                                      );

        } else { // it's smaller than desktop

                this.getBus().getAdRepositioner().repositionAd(
                                                                                        {
                                                                                                target: "#tertiary_ad_location",
                                                                                                source: "#leaderboard_ad"
                                                                                        },
                                                                                        {},
                                                                                        [this.getBus().getViewporter().getMobileId(), this.getBus().getViewporter().getTabletId()]
                                                                                       );

        }

    };

};
IVYEXEC.LeaderboardAd.prototype = new IVYEXEC.Ad();
IVYEXEC.LeaderboardAd.prototype.constructor = IVYEXEC.LeaderboardAd;
